module.exports = __webpack_public_path__ + "static/img/sw1.84cd0535.png";